// DisclaimerMessage.js
import React from 'react';
import MarkdownRenderer from '../utils/MarkdownRenderer';

export const DISCLAIMER_TEXT = `Aloha and welcome to the Hawai'i State Judiciary Chatbot. Before we begin, please review and agree to the following terms before proceeding:


By using the Hawai'i State Judiciary website ("Website") and KolokoloChat ("Chatbot"), you acknowledge and agree to the following terms:
1. **General Information Only (This is not legal advice):** 
  The information provided by the Website and the Chatbot is for general informational purposes only and does not constitute legal advice.  It is not a substitute for professional legal advice from an attorney.  The Chatbot is designed to assist with general inquiries and navigation of the Website but does not offer personalized legal solutions.  You should consult with an attorney for legal advice regarding your individual situation.

2. **User Responsibility for Actions Taken:**
  The Hawai'i State Judiciary assumes no liability for any actions taken based on information obtained from the Website and the Chatbot.  We strive to provide accurate information, but errors may occur.  Users are responsible for verifying any information obtained from the Chatbot with official resources or legal professionals before taking any action.

3. **Service Modifications:**
  The Hawai'i State Judiciary reserves the right to modify, suspend, or discontinue the Chatbot service at any time.

4. **Do Not Share Your Personally Identifiable Information (PII):**
  The Hawai'i State Judiciary is not responsible for any privileged, confidential, or personally identifiable information (PII) that users submit to the Chatbot.  While we take precautions to implement security measures for the Chatbot, PII and privileged or confidential information provided by users through the Chatbot are not within the Judiciary's scope of liability.  The Chatbot is not a secure platform for transmitting sensitive or confidential information.  To protect your privacy, please submit only general questions related to your situation and do not share any PII or other sensitive, privileged, or confidential information with the Chatbot.

5. **Prohibited Activities:** 
  By using the Website and Chatbot, you agree not to engage in any unauthorized or inappropriate use of the Chatbot that deviates from its intended purpose.  This includes, but is not limited to, attempts to exploit, disrupt, or otherwise abuse the Chatbot's functionality through methods such as brute force attacks or any other form of abusive activity. Such actions are strictly prohibited and may result in immediate termination of access to the Chatbot and potential enforcement action.

6. **Agreement to Terms:** 
  Do you agree to these terms? (Please respond with **'Agree'** or **'Disagree'**)`;

const DisclaimerMessage = ({ className = '' }) => {
  return (
    <div className={`bg-white shadow-lg rounded-lg border border-gray-200 ${className}`}>
      <div className="p-6">
        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
          <h2 className="text-2xl font-bold text-blue-800 mb-2">Terms and Conditions</h2>
          <p className="text-blue-600">Please read the following terms carefully before proceeding.</p>
        </div>
        <div className="prose max-w-none text-gray-700 whitespace-pre-wrap">
          <MarkdownRenderer>
            {DISCLAIMER_TEXT}
          </MarkdownRenderer>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerMessage;
